import React, { Component } from 'react';

import BusSeatNew from '../BusSeatNew';
import Loader from '../common/loader'
/* import BusSeat from '../BusSeat'; */

import './styles.css'

import driver from '../../images/driver.svg';

class SeatMap extends Component {
  constructor(props) {
    super(props);
    this.selectSeatHandler = this.selectSeatHandler.bind(this);
  }

  getBusSeatsNumber(selectedSeats) {
    const {dynamicSeatData, busDetails} = this.props;
    const current_rtd = busDetails && busDetails.id;
    // Filter selectedSeats based on the condition
    const matchingSeats = selectedSeats.filter((seat) => {
      const seatNumber = JSON.parse(seat).rtid;
      return seatNumber === current_rtd;
    });
    const row = matchingSeats.map((seat) => JSON.parse(seat).seat_number);
    return row.join(', ');
  }
  

  getBusSeatsPrice(selectedSeats) {
    let sum = 0;
    for (let i = 0; i < selectedSeats.length; i++) {
      let fare, seat = JSON.parse(selectedSeats[i]);
      if(isNaN(seat.revisedBaseFare)){
        fare = seat.baseFare;
      }
      else{
        fare = seat.revisedBaseFare;
      }
      sum += parseFloat(fare);
    }
    return parseFloat(sum.toFixed(2));
  }

  buildSeatData() {
    const bus = {
      seats: [],
      seatsUpper: [],
    };
    if (this.props.seatMap && this.props.seatMap.body) {
      this.props.seatMap.body.forEach(function (seat, key) {
        if (seat.isLowerBerth) {
          bus.seats[seat.row] = bus.seats[seat.row] ? bus.seats[seat.row] : [];
          bus.seats[seat.row][seat.column] = seat;
        } else {
          bus.seatsUpper[seat.row] = bus.seatsUpper[seat.row] ? bus.seatsUpper[seat.row] : [];
          bus.seatsUpper[seat.row][seat.column] = seat;
        }
      });
    }
    return bus;
  }

  buildNewRow(str, seatsArr, selectedSeats, fareSelected){
    let i, row = [], j = 0, incrementI;
    for(i = 0; i < str.length;){
      incrementI = true;
      if(str[i] === 'e'){
        row.push(<BusSeatNew key={i} seat={null} />);
      }
      else if(str[i] === 's'){
        row.push(<BusSeatNew key={i} seat={seatsArr[j]} selectedSeats={selectedSeats} fareSelected={fareSelected} selectSeatHandler={this.props.selectSeatHandler} />);
        j++;
      }
      else if (str[i] === 'S' && str[i+1] === 'L'){
        row.push(<BusSeatNew key={i} seat={seatsArr[j]} selectedSeats={selectedSeats} fareSelected={fareSelected} selectSeatHandler={this.props.selectSeatHandler}  />);
        j++;
        incrementI = false;
        i += 2;
      }
      if(incrementI)
        i++;
    }

    if(j !== seatsArr.length) {
      //overlapping seats
      row = row.concat(seatsArr.slice(j).map((v,i) => <BusSeatNew key={`extras-${i}`} seat={v} selectedSeats={selectedSeats} fareSelected={fareSelected} selectSeatHandler={this.props.selectSeatHandler} />));
    }
    return row;
  }

  buildNewLayout(stringArr, seatsArr, isUpper, selectedSeats, fareSelected){
    const row = [];
    let i;
    let result;
 
    for (i = 0; i < stringArr.length; i++) {
      result = [];
      if(stringArr[i]){
        result = result.concat(this.buildNewRow(stringArr[i], seatsArr[i], selectedSeats, fareSelected));
        row.push(<div className='row seatRow' key={`bus-new-seat-row-${i}`}>{result}</div>);
      } else {
        row.push(<div className='row emptySeatRow' key={`empty-row-${i}`}></div>);
      }
    }
    return row;
  }

  selectSeatHandler(seat) {
    const seatStringify = JSON.stringify(seat);
    const { selectedSeats } = this.state;

    let seatIndex = -1;
      
    seatIndex = selectedSeats.indexOf(seatStringify);
    if (seatIndex === -1) {
      selectedSeats.push(JSON.stringify(seat));
    } else if (seatIndex !== -1) {
      selectedSeats.splice(seatIndex, 1);
    }
    const updateSeat = [...selectedSeats];
    this.setState({selectedSeats: updateSeat});
  }

  componentDidMount() {

    const {selectedSeats, onSearvicesSelection, dataServiceList, dealType, isEdit}= this.props;
    if(isEdit) {
      dataServiceList && dataServiceList.map((serviceList) => { 
        onSearvicesSelection(
         serviceList.id,
         false,
         dealType,
         serviceList);
         onSearvicesSelection(serviceList, false, dealType, serviceList);
     })
    }
  

    this.props.getSeat(selectedSeats);
    // localStorage.setItem('seat_selected', JSON.stringify(selectedSeats || []));
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedSeats !== this.props.selectedSeats) {
      const {dynamicSeatData, busDetails} = this.props;
    const current_rtd = busDetails && busDetails.id;
    const matchingSeats = this.props.selectedSeats.filter((seat) => {
      const seatNumber = JSON.parse(seat).rtid;
      return seatNumber === current_rtd;
    });
    const row = matchingSeats.map((seat) => JSON.parse(seat).seat_number);
    const updatedSeatData = {
      ...dynamicSeatData,
      [current_rtd]: row,
    }
    this.props.setDynamicSeatData(updatedSeatData);
    }
  }

  render() {
    const { seatMap=[], seatMapError, selectedSeats } = this.props;
    // const seatDataString = localStorage.getItem('seat_selected');
    // const seatData = seatDataString ? JSON.parse(seatDataString) : [];
    // const seatCliked = localStorage.getItem('seatCliked');
    // const { selectedSeats } = this.props.isEdit && seatCliked == true ? { selectedSeats: seatData } : this.props || [];
    return (
      <div>
        <div className={seatMapError && seatMapError.isError ? 'seatMapContainerError' : 'seatMapContainer'} >
          <div className="row between-xs">
            {
              seatMapError && seatMapError.isError && <div className='errorFetching '>There was an error fetching the seatmap{`, ${seatMapError.payload}`}.</div>
            }
            {
              seatMap && seatMap.seats &&
              <div className='col-xs-10 seatContainerDisabled'>
                {/*
                  seatMap.seats.length === 0 && seatMap.seatsUpper.length === 0 && !seatMap.error && !seatMapError &&
                  <Loader />
                */}

               
                <div className="row">
                  {
                    seatMap && (seatMap.error) &&
                    <div className='errorFetching'>{seatMap.error}</div>
                  }

                  {
                    seatMap.seats.length > 0 ?
                      <div className='deckContainer'>
                        <div className='verticalText front'>Front</div>
                        <div className='verticalText rear'>Rear</div>
                        <div className='newDriver'><img src={driver} className='width100' /></div>
                        {
                          seatMap.seats.length > 0 && seatMap.seatsUpper.length > 0 &&
                          <div className='verticalText deckType'>Lower</div>
                        }
                        <div className='seatContainer'>
                          {this.buildNewLayout(seatMap.smStringLower, seatMap.lowerCollection, false, selectedSeats)}
                        </div>
                      </div> : ''
                  }
                  {
                    seatMap.seatsUpper.length ?
                      <div className='deckContainer'>
                        <div className='verticalText front'>Front</div>
                        <div className='verticalText rear'>Rear</div>
                        <div className='verticalText deckType'>Upper</div>
                        <div className='seatContainer'>
                          {this.buildNewLayout(seatMap.smStringUpper, seatMap.upperCollection, true, selectedSeats)}
                        </div>
                      </div> : ''
                  }
                </div>
              </div>
            }
          </div>
        </div>
        <div className='seatsSelected'>
        {
          selectedSeats.length > 0 && 
          <div className="row between-xs">
            <div className='col-xs-5 selectedSeatNumbers'>
              Selected Seat Numbers:{this.getBusSeatsNumber(selectedSeats)}
            </div>
          </div>
        }
        </div>
      </div>
      
          
    );
  }
}

export default SeatMap;
